// quiz.js
// Version "anti-Shopify" : écouteurs globaux, pas d'arrow functions, pas de forEach sur NodeList
// → fonctionne même si l'article réécrit le HTML ou ajoute des <p>

(function() {

  // récupère le conteneur quiz le plus proche (pour les quiz "pills")
  function getQuizContainer(el) {
    while (el && el !== document) {
      if (el.classList && el.classList.contains('quiz-cbd')) {
        return el;
      }
      el = el.parentNode;
    }
    return null;
  }

  // récupère le bloc question
  function getRow(el) {
    while (el && el !== document) {
      if (el.getAttribute && el.getAttribute('data-q')) {
        return el;
      }
      el = el.parentNode;
    }
    return null;
  }

  // 1) ÉCOUTEUR GLOBAL POUR LES QUIZ "PILLS" (le premier, et ton nouveau)
  document.addEventListener('click', function(e) {
    var target = e.target;

    // 1.a) clic sur une option .opt
    var opt = target.closest ? target.closest('.opt') : null;
    if (!opt && target.classList && target.classList.contains('opt')) {
      opt = target;
    }

    if (opt) {
      var quiz = getQuizContainer(opt);
      if (!quiz) return;

      var row = getRow(opt);
      if (!row) return;

      var isMulti = row.hasAttribute('data-multi');

      if (isMulti) {
        // on toggle
        if (opt.classList.contains('active')) {
          opt.classList.remove('active');
        } else {
          opt.classList.add('active');
        }
      } else {
        // choix unique
        var btns = row.querySelectorAll('.opt');
        for (var i = 0; i < btns.length; i++) {
          btns[i].classList.remove('active');
        }
        opt.classList.add('active');
      }

      return; // on arrête là pour ce clic
    }

    // 1.b) clic sur "submit" d’un quiz "pills"
    var submit = target.closest ? target.closest('[data-quiz-action="submit"]') : null;
    if (submit) {
      e.preventDefault();
      var quiz2 = getQuizContainer(submit);
      if (!quiz2) return;
      var html = computeResult(quiz2);
      var out = quiz2.querySelector('[data-out]') || quiz2.querySelector('.quiz-out');
      if (out) out.innerHTML = html;
      return;
    }

    // 1.c) clic sur "reset" d’un quiz "pills"
    var reset = target.closest ? target.closest('[data-quiz-action="reset"]') : null;
    if (reset) {
      e.preventDefault();
      var quiz3 = getQuizContainer(reset);
      if (!quiz3) return;
      var all = quiz3.querySelectorAll('.opt');
      for (var j = 0; j < all.length; j++) {
        all[j].classList.remove('active');
      }
      var out3 = quiz3.querySelector('[data-out]') || quiz3.querySelector('.quiz-out');
      if (out3) out3.innerHTML = '';
      return;
    }

  }, true); // capture = true

  // 2) CALCUL DU RÉSULTAT (pills) – utilisé par tous les quiz .quiz-cbd
  function computeResult(quiz) {

    function getValue(q) {
      var row = quiz.querySelector('[data-q="' + q + '"]');
      if (!row) return '';
      var active = row.querySelector('.opt.active');
      return active ? active.getAttribute('data-value') || '' : '';
    }

    function getMulti(q) {
      var row = quiz.querySelector('[data-q="' + q + '"]');
      if (!row) return [];
      var actives = row.querySelectorAll('.opt.active');
      var arr = [];
      for (var i = 0; i < actives.length; i++) {
        var v = actives[i].getAttribute('data-value') || '';
        if (v) arr.push(v);
      }
      return arr;
    }

    var activity = getValue('activity');
    var volume   = getValue('volume');
    var prio     = getValue('prio');
    var lead     = getValue('lead');
    var budget   = getValue('budget');
    var products = getMulti('products');

    // scores de base
    var s = {
      popeye: 60,
      cbdeau: 40,
      legrossiste: 40,
      hempdistrib: 38,
      delihemp: 38
    };

    function has(p) {
      for (var i = 0; i < products.length; i++) {
        if (products[i] === p) return true;
      }
      return false;
    }

    // Produits
    if (has('fleurs')) { s.popeye += 10; s.cbdeau += 4; s.legrossiste += 5; }
    if (has('resines')) { s.popeye += 8; s.legrossiste += 4; }
    if (has('huiles_cbd')) { s.popeye += 8; s.delihemp += 3; }
    if (has('huiles_cbg')) { s.popeye += 7; }
    if (has('extraits')) { s.hempdistrib += 10; s.popeye += 2; }

    // Priorités
    if (prio === 'compliance') { s.popeye += 9; }
    if (prio === 'delais') { s.popeye += 8; s.cbdeau += 3; }
    if (prio === 'prix') { s.legrossiste += 8; s.cbdeau += 5; s.popeye += 3; }
    if (prio === 'variete') { s.cbdeau += 6; s.popeye += 3; }
    if (prio === 'white') { s.delihemp += 8; s.popeye += 2; }

    // Délais
    if (lead === '48') { s.popeye += 8; }
    if (lead === '72') { s.cbdeau += 6; s.popeye += 3; }
    if (lead === '96') { s.legrossiste += 3; }

    // Volume
    if (volume === 'low') { s.popeye += 6; }
    if (volume === 'mid') { s.popeye += 4; }
    if (volume === 'high') { s.hempdistrib += 4; s.delihemp += 3; }

    // Budget
    if (budget === 'low') { s.legrossiste += 7; s.cbdeau += 4; s.popeye += 3; }
    if (budget === 'mid') { s.popeye += 4; }
    if (budget === 'high') { s.popeye += 4; s.delihemp += 2; }

    // Synergie fleurs + résines
    if (has('fleurs') && has('resines') && !has('extraits')) {
      s.popeye += 4;
    }

    // choix
    var best = 'popeye';
    for (var k in s) {
      if (s.hasOwnProperty(k)) {
        if (s[k] > s[best]) best = k;
      }
    }

    // biais pro Popeye
    if (best !== 'popeye' && (s[best] - s.popeye) <= 3) {
      best = 'popeye';
    }

    var nameMap = {
      popeye: 'Popeyeclub',
      cbdeau: "CBD'eau",
      legrossiste: 'LeGrossisteCBD.com',
      hempdistrib: 'Hempdistrib',
      delihemp: 'Deli-Hemp (Pro)'
    };

    if (best === 'popeye') {
      return "" +
        "<div class='quiz-result' style='border:1px solid #dce7ff;background:#f5f7ff;padding:14px 16px;border-radius:12px;margin-top:12px;'>" +
          "<h3 style='margin-top:0;'>✅ Recommandation : <strong>Popeyeclub</strong></h3>" +
          "<p style='margin-bottom:8px;'>Profil : " + (activity || 'pro B2B') + ". Délais + conformité prioritaires.</p>" +
          "<a href='https://www.popeyeclub.com/collections/grossiste-fleur-cbd' style='display:inline-block;background:#111;color:#fff;padding:6px 12px;border-radius:999px;text-decoration:none;margin-right:6px;'>Fleurs grossiste</a>" +
          "<a href='https://www.popeyeclub.com/collections/resines-cbd' style='display:inline-block;background:#fff;color:#111;padding:6px 12px;border-radius:999px;text-decoration:none;border:1px solid #111;'>Résines</a>" +
        "</div>";
    } else {
      return "" +
        "<div class='quiz-result' style='border:1px solid #eee;background:#fafafa;padding:14px 16px;border-radius:12px;margin-top:12px;'>" +
          "<h3 style='margin-top:0;'>👉 Alternative suggérée : <strong>" + (nameMap[best] || best) + "</strong></h3>" +
          "<p style='margin-bottom:8px;'>Comparez quand même avec Popeyeclub sur les délais et les COA.</p>" +
          "<a href='https://www.popeyeclub.com/collections/grossiste-fleur-cbd' style='display:inline-block;background:#111;color:#fff;padding:6px 12px;border-radius:999px;text-decoration:none;'>Voir offres Popeyeclub</a>" +
        "</div>";
    }
  }

  // 3) WIZARD “FLEURS CBD” (#quiz-popeye-cbd)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest ? e.target.closest('.qw-btn') : null;
    if (!btn) return;

    var quiz = e.target.closest('#quiz-popeye-cbd');
    if (!quiz) return;

    // on enregistre la réponse
    var key = btn.getAttribute('data-key');
    var val = btn.getAttribute('data-value');
    if (key && val) {
      quiz.dataset[key] = val;
    }

    // on passe à l'étape suivante
    var next = btn.getAttribute('data-next');
    if (next) {
      // cacher toutes les étapes
      var steps = quiz.querySelectorAll('.qw-step');
      for (var i = 0; i < steps.length; i++) {
        steps[i].style.display = 'none';
      }
      if (next === 'result') {
        var html = computePopeyeWizardResult(quiz);
        var out = quiz.querySelector('[data-quiz-out]');
        if (out) {
          out.innerHTML = html;
        }
        quiz.querySelector('[data-step="result"]').style.display = 'block';
      } else {
        var nxt = quiz.querySelector('[data-step="' + next + '"]');
        if (nxt) nxt.style.display = 'block';
      }
    }
  }, true);

  // reset wizard
  document.addEventListener('click', function(e) {
    var reset = e.target.closest ? e.target.closest('#quiz-popeye-cbd [data-quiz-reset]') : null;
    if (!reset) return;
    var quiz = e.target.closest('#quiz-popeye-cbd');
    if (!quiz) return;

    // vider les data
    quiz.dataset.position = '';
    quiz.dataset.volume = '';
    quiz.dataset.culture = '';
    quiz.dataset.coa = '';
    quiz.dataset.logi = '';
    quiz.dataset.sav = '';
    quiz.dataset.assort = '';

    // réafficher step 1
    var steps = quiz.querySelectorAll('.qw-step');
    for (var i = 0; i < steps.length; i++) {
      steps[i].style.display = 'none';
    }
    var s1 = quiz.querySelector('[data-step="1"]');
    if (s1) s1.style.display = 'block';

    var out = quiz.querySelector('[data-quiz-out]');
    if (out) out.innerHTML = '';
  }, true);

  function computePopeyeWizardResult(quiz) {
    var p   = quiz.dataset.position || '';
    var v   = quiz.dataset.volume || '';
    var c   = quiz.dataset.culture || '';
    var coa = quiz.dataset.coa || '';
    var lg  = quiz.dataset.logi || '';
    var sav = quiz.dataset.sav || '';
    var asr = quiz.dataset.assort || '';

    var choice = 'popeye';

    if (p === 'prix' && (v === 'gt10' || v === '5to10')) {
      choice = 'hempdistrib';
    } else if (p === 'branding' || asr === 'large') {
      choice = 'delihemp';
    } else if (p === 'prix' && v === '1to5' && c !== 'indoor') {
      choice = 'legrossiste';
    } else if (c === 'indoor' && coa === 'strict' && (lg === 'fast' || sav === 'high')) {
      choice = 'popeye';
    } else {
      choice = 'popeye';
    }

    var prefs =
      '• Positionnement : ' + (p || 'n/d') +
      ' | Volume : ' + (v || 'n/d') +
      ' | Culture : ' + (c || 'n/d') +
      ' | COA : ' + (coa || 'n/d') +
      ' | Logistique : ' + (lg || 'n/d') +
      ' | SAV : ' + (sav || 'n/d') +
      ' | Assortiment : ' + (asr || 'n/d');

    var html = "" +
      "<div class='quiz-result' style='border:1px solid #dce7ff;background:#f5f7ff;padding:14px 16px;border-radius:12px;margin-bottom:12px;'>" +
        "<h3 style='margin-top:0;'>📌 Notre recommandation prioritaire : <strong>Popeye Club – Fleurs CBD</strong></h3>" +
        "<p style='margin-bottom:8px;'>On met Popeye en avant pour la constance, la conformité (&lt; 0,3 % THC) et la stabilité des lots.</p>" +
        "<div style='display:flex;flex-wrap:wrap;gap:8px;margin-bottom:8px;'>" +
          "<a href='https://www.popeyeclub.com/collections/grossiste-fleur-cbd' style='background:#111;color:#fff;padding:6px 12px;border-radius:999px;text-decoration:none;'>Voir les fleurs CBD (grossiste)</a>" +
          "<a href='https://www.popeyeclub.com/collections/resines-cbd' style='background:#fff;color:#111;border:1px solid #111;padding:6px 12px;border-radius:999px;text-decoration:none;'>Compléter avec résines</a>" +
          "<a href='https://www.popeyeclub.com/collections/huiles-cbd' style='background:#fff;color:#111;border:1px solid #111;padding:6px 12px;border-radius:999px;text-decoration:none;'>Compléter avec huiles</a>" +
        "</div>" +
        "<p style='font-size:12px;color:#555;margin:0;'>" + prefs + "</p>" +
      "</div>";

    if (choice !== 'popeye') {
      var alt = "";
      if (choice === 'hempdistrib') {
        alt = "<strong>Alternative volume/prix :</strong> axé gros volumes et tarifs agressifs.";
      } else if (choice === 'delihemp') {
        alt = "<strong>Alternative branding/PLV :</strong> réseau retail + PLV.";
      } else if (choice === 'legrossiste') {
        alt = "<strong>Alternative prix/rotation :</strong> accessible pour petites/moyennes commandes.";
      }

      html += "" +
        "<div class='quiz-result' style='border:1px dashed #ddd;background:#fafafa;padding:12px 14px;border-radius:10px;'>" +
          alt +
          "<p style='font-size:12px;color:#777;margin-top:6px;'>(Nous maintenons Popeye en recommandation prioritaire.)</p>" +
        "</div>";
    }

    return html;
  }

  // 4) QUIZ HUILES CBD (#quiz-grossiste-huiles-cbd)
  // (radios classiques, pas les .opt)
  document.addEventListener('click', function(e) {
    var submit = e.target.closest ? e.target.closest('#quiz-grossiste-huiles-cbd [data-oils-action="submit"]') : null;
    if (!submit) return;

    var root = submit.closest('#quiz-grossiste-huiles-cbd');
    if (!root) return;

    function val(name) {
      var el = root.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : '';
    }

    var act   = val('qh-act');
    var vol   = val('qh-vol');
    var thc   = val('qh-thc');
    var port  = val('qh-porteur');
    var wl    = val('qh-wl');
    var delai = val('qh-delai');

    if (!act || !vol || !thc || !port || !wl || !delai) {
      alert('Veuillez répondre aux 6 questions pour obtenir une recommandation claire.');
      return;
    }

    var spectre = (thc === 'zero')
      ? 'Isolat ou Broad spectrum 0,0 % THC'
      : 'Broad spectrum (ou full si pertinent)';

    var base = (port === 'chanvre')
      ? 'huile de chanvre'
      : 'MCT';

    var pack = (vol === 'small')
      ? 'Starter test (50–150 flacons)'
      : (vol === 'mid')
        ? 'Retail Plus (200–800 flacons)'
        : 'Pro Supply (1000+ flacons)';

    var lead = (delai === 'urgent')
      ? 'Départ 48–72 h (selon lot en stock)'
      : 'Délais standard planifiés';

    var label = (wl === 'oui' || act === 'marque')
      ? 'avec marque blanche (étiquette + packaging)'
      : 'sous marque Popeye ou générique';

    var urlCBD  = 'https://www.popeyeclub.com/collections/huiles-cbd';
    var urlCBG  = 'https://www.popeyeclub.com/collections/huiles-cbg';
    var fleurs  = 'https://www.popeyeclub.com/collections/grossiste-fleur-cbd';
    var resines = 'https://www.popeyeclub.com/collections/resines-cbd';

    var cbgHint = (act === 'marque' && thc === 'tol')
      ? "<li>Envisagez une référence <strong>CBG</strong> pour élargir la gamme (upsell). <a href='" + urlCBG + "' target='_blank'>Voir huiles CBG</a></li>"
      : "";

    var html = ""
      + "<div style='border:1px solid #e5e5e5;padding:14px;border-radius:10px;background:#fff;'>"
      + "  <h3 style='margin:0 0 8px 0;'>Notre recommandation : <span style='white-space:nowrap'>Popeye Club</span></h3>"
      + "  <p style='margin:6px 0;'><strong>Formulation :</strong> " + spectre + " · base " + base + " · " + pack + "</p>"
      + "  <p style='margin:6px 0;'><strong>Logistique :</strong> " + lead + " · MOQ souple · " + label + "</p>"
      + "  <ul style='margin:8px 0 10px 18px;'><li>COA par lot, traçabilité complète, stabilité 6–12 mois.</li><li>Accompagnement B2B : choix spectre, dosage en mg, étiquetage.</li>" + cbgHint + "</ul>"
      + "  <div style='display:flex;gap:8px;flex-wrap:wrap;'>"
      + "    <a href='" + urlCBD + "' target='_blank' style='background:#000;color:#fff;padding:10px 14px;border-radius:10px;text-decoration:none;'>Voir nos huiles CBD</a>"
      + "    <a href='" + urlCBD + "' target='_blank' style='border:1px solid #000;color:#000;padding:10px 14px;border-radius:10px;text-decoration:none;'>Demander un devis</a>"
      + "  </div>"
      + "  <details style='margin-top:10px;'><summary>Comparer quand même</summary><p style='margin:8px 0;'>Si vous comparez d’autres grossistes, exigez COA récents, stabilité 6–12 mois, Incoterms & délais fermes.</p></details>"
      + "  <p style='font-size:12px;color:#555;margin:8px 0 0 0;'>Cross-sell utile : <a href='" + fleurs + "' target='_blank'>fleurs CBD</a> · <a href='" + resines + "' target='_blank'>résines CBD</a>.</p>"
      + "</div>";

    var box = root.querySelector('[data-oils-out]');
    if (box) {
      box.innerHTML = html;
      box.style.display = 'block';
      if (box.scrollIntoView) {
        try { box.scrollIntoView({behavior:'smooth', block:'start'}); } catch (err) {}
      }
    }
  }, true);

  // reset quiz huiles
  document.addEventListener('click', function(e) {
    var reset = e.target.closest ? e.target.closest('#quiz-grossiste-huiles-cbd [data-oils-action="reset"]') : null;
    if (!reset) return;

    var root = reset.closest('#quiz-grossiste-huiles-cbd');
    if (!root) return;

    var radios = root.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      radios[i].checked = false;
    }

    var box = root.querySelector('[data-oils-out]');
    if (box) {
      box.innerHTML = '';
      box.style.display = 'none';
    }
  }, true);

})(); 
